import panel_date_pick_vue_vue_type_script_setup_true_lang_default from "./panel-date-pick.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/panel-date-pick.vue
var panel_date_pick_default = panel_date_pick_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_date_pick_default as default };
//# sourceMappingURL=panel-date-pick.mjs.map